import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlansPriceService, PlansPrice } from '../../services/plans-price.service';
import { PlansService, Plan } from '../../services/plans.service'; // importe o PlansService
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreatePriceModalComponent } from './modals/create-price-modal.component';
import { ConfirmDialogComponent } from '../../shared/components/ConfirmDialogComponent';

@Component({
  selector: 'app-plan-prices',
  templateUrl: './plan-prices.component.html',
  styleUrls: ['./plan-prices.component.scss']
})
export class PlanPricesComponent implements OnInit {
  planId!: number;
  planName: string = ''; 
  prices: PlansPrice[] = [];
  page: number = 1;
  search: string = '';
  totalItems: number = 0;
  isFilterApplied: boolean = false; 

  constructor(
    private route: ActivatedRoute,
    private plansPriceService: PlansPriceService,
    private plansService: PlansService, 
    private dialog: MatDialog,
    private snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.planId = +this.route.snapshot.paramMap.get('id')!;
    this.plansService.getPlan(this.planId).subscribe((plan: Plan) => {
      this.planName = plan.name;
    }, error => {
      this.snack.open('Erro ao buscar o plano', 'OK', { duration: 4000 });
    });
    this.loadPrices();
  }

  loadPrices(): void {
    this.plansPriceService.getPrices(this.planId, this.page, this.search)
      .subscribe((response: any) => {
        this.prices = response.data;
        this.totalItems = response.total;
      });
  }

  onSearch(): void {
    if (this.search.trim() !== '') {
      this.isFilterApplied = true;
    }
    this.page = 1;
    this.loadPrices();
  }

  clearFilters(): void {
    this.search = '';
    this.isFilterApplied = false;
    this.page = 1;
    this.loadPrices();
  }

  openCreatePriceModal(): void {
    const dialogRef = this.dialog.open(CreatePriceModalComponent, { width: '400px' });
    dialogRef.afterClosed().subscribe((result: { price: number, startDate: string }) => {
      if (result) {
        this.plansPriceService.createPrice(this.planId, result.price, result.startDate)
          .subscribe(() => {
            this.loadPrices();
            this.snack.open('Preço criado com sucesso!', 'OK', { duration: 4000 });
          }, error => {
            this.snack.open('Erro ao criar o preço: ' + error.error.message, 'OK', { duration: 4000 });
          });
      }
    });
  }

  deletePrice(price: PlansPrice): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { message: 'Deseja realmente excluir este preço?' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.plansPriceService.deletePrice(this.planId, price.id)
          .subscribe(() => {
            this.loadPrices();
            this.snack.open('Preço excluído com sucesso!', 'OK', { duration: 4000 });
          }, error => {
            this.snack.open('Erro ao excluir o preço: ' + error.error.message, 'OK', { duration: 4000 });
          });
      }
    });
  }

  canDeletePrice(price: PlansPrice): boolean {
    const today = new Date();
    const startDate = new Date(price.startDate);
    return startDate > today;
  }

  changePage(newPage: number): void {
    if (newPage < 1) return;
    this.page = newPage;
    this.loadPrices();
  }
}
